<template>
  <div class="vp-list-item-wrap" :style="style">
    <slot name="row">
      <div class="item-row">
        <slot name="label">
          <span class="label">{{ label }}</span>
        </slot>
        <slot name="value">
          <span class="value">{{ value }}</span>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  },
  inject: ['calc'],
  data() {
    return {
      normalStyle: {
        padding: `${this.calc(27)} 0`,
        borderBottom: '1px solid #646364',
        color: '#cecece',
        fontSize: this.calc(28)
      }
    };
  },
  computed: {
    style() {
      const filter = { ...this.customStyle };
      if (!this.hasBorder) filter.borderBottom = 'unset';
      return Object.assign(this.normalStyle, filter);
    }
  }
};
</script>

<style lang="scss">
.vp-list-item-wrap {
  .item-row {
    display: flex;
    justify-content: space-between;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #f1f0f0;
    &:last-of-type {
      margin-bottom: unset !important;
    }
  }
}
</style>
